import { createFileRoute, redirect } from "@tanstack/react-router";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Separator } from "@/components/ui/separator";
import { EmailAuthForm, OAuthButtons } from "@/components/auth";
import { supabase } from "@/lib/supabase";
import { useState } from "react";

export const Route = createFileRoute("/auth/login")({
  component: LoginPage,
  beforeLoad: async () => {
    const {
      data: { session },
    } = await supabase.auth.getSession();
    if (session) {
      throw redirect({ to: "/dashboard/playground" });
    }
  },
});

function LoginPage() {
  const [error, setError] = useState("");

  const handleAuthError = (errorMessage: string) => {
    setError(errorMessage);
  };

  const handleAuthSuccess = () => {
    setError("");
    // Additional success handling can be added here if needed
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-blue-50 via-purple-50 to-yellow-50 flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <CardTitle className="text-2xl font-bold">Welcome</CardTitle>
          <CardDescription>Sign in to your account to continue</CardDescription>
        </CardHeader>
        <CardContent className="space-y-4">
          {/* Global Error Display */}
          {error && (
            <div className="text-sm text-red-600 text-center p-3 bg-red-50 rounded-md border border-red-200">
              {error}
            </div>
          )}

          {/* Email Authentication Form */}
          {/* <EmailAuthForm
            onSuccess={handleAuthSuccess}
            onError={handleAuthError}
          /> */}

          {/* Separator */}
          {/* <div className="relative">
            <div className="absolute inset-0 flex items-center">
              <Separator className="w-full" />
            </div>
            <div className="relative flex justify-center text-xs uppercase">
              <span className="bg-white px-2 text-gray-500">
                Or continue with
              </span>
            </div>
          </div> */}

          {/* OAuth Buttons */}
          <OAuthButtons onError={handleAuthError} />

          {/* Terms and Privacy */}
          <p className="text-xs text-center text-gray-500">
            By signing in, you agree to our Terms of Service and Privacy Policy
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
